import { put, takeLatest } from "redux-saga/effects";
import { IEmployee } from "src/common/types";
import { fetchMyEmployees } from "src/redux/actions";

export function* fetchMyEmployeesList({ payload }: { type: "GET_MY_EMPLOYEES_LIST"; payload: "ACTIVE" | "EXPIRED" }) {
  try {
    const { entities } = yield fetchMyEmployees(payload);

    yield put({
      payload: entities.filter(({ talks }: IEmployee) => talks.length),
      type: "GET_MY_EMPLOYEES_LIST_FULFILLED"
    });
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error(e);
    yield put({
      type: "GET_MY_EMPLOYEES_LIST_REJECTED"
    });
  }
}

export default function* feedbackWatcher() {
  yield takeLatest("GET_MY_EMPLOYEES_LIST", fetchMyEmployeesList);
}
